import * as Sentry from '@sentry/browser';
import { useDispatch } from 'react-redux';
import { setError } from 'src/redux/slices/error';
import store from 'src/redux/store';

const useError = () => {
  const dispatch = useDispatch();

  const setErrorFn = (id: string) => {
    dispatch(setError({ id }));
  };

  return {
    setError: setErrorFn
  }
};

export const reportError = (error: any) => {
  const { auth } = store.getState();
  
  const errorId: string = Sentry.withScope(() => {
    return Sentry.withScope(() => {
      Sentry.setUser({
        id: auth.currentUser?.id,
        username: auth.currentUser?.username,
      });
      Sentry.setExtra('accountId', auth.currentAccount?.id);
      Sentry.setExtra('userId', auth.currentUser?.id);

      return Sentry.captureException(error);
    });
  });

  return errorId;
}

export default useError;
